<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';

import ConversationCard from 'dashboard/components-next/Conversation/ConversationCard/ConversationCard.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

defineProps({
  conversations: {
    type: Array,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();
const contactsById = useMapGetter('contacts/getContactById');
const stateInbox = useMapGetter('inboxes/getInboxById');
const accountLabels = useMapGetter('labels/getLabels');

const accountLabelsValue = computed(() => accountLabels.value);
const conversationContact = conversation => {
  const sender = conversation.meta?.sender || {};
  const contact = contactsById.value(sender.id);
  return contact.id ? contact : sender;
};
const conversationInbox = conversation =>
  stateInbox.value(conversation.inboxId) || {
    name: '',
    channelType: conversation.meta?.channel,
  };
</script>

<template>
  <div
    v-if="isLoading"
    class="flex items-center justify-center py-10 text-auth-muted dark:text-auth-muted-dark"
  >
    <Spinner />
  </div>

  <div
    v-else-if="conversations.length > 0"
    class="divide-y divide-auth-border px-5 dark:divide-auth-border-dark sm:px-6 [&>*:hover+*]:!border-t-transparent [&>*:hover]:!border-y-transparent"
  >
    <ConversationCard
      v-for="conversation in conversations"
      :key="conversation.id"
      :conversation="conversation"
      :contact="conversationContact(conversation)"
      :state-inbox="conversationInbox(conversation)"
      :account-labels="accountLabelsValue"
      class="rounded-none hover:rounded-xl hover:bg-auth-surface/70 dark:hover:bg-auth-surface-dark/70"
    />
  </div>

  <p
    v-else
    class="mx-5 rounded-xl border border-dashed border-auth-border px-4 py-8 text-center text-sm text-auth-muted dark:border-auth-border-dark dark:text-auth-muted-dark sm:mx-6"
  >
    {{ t('COMPANIES.DETAIL.HISTORY.EMPTY') }}
  </p>
</template>
